import React from 'react';
import ReactDom from 'react-dom';
import { Transfer, Button } from 'antd';
import { addCtnCommonAttribute } from "./SgiCtnComm";
import { convertModuleByGuid } from "./SgiCompComm";
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory';
import { uuid, copyArr } from "rt-sd-common/sgiCommon/sgiCommon";
import { getConstByKey } from './sgiBaseComp/SgiCommon';



const tranFConfConstant = {
    key: 'key'
}
class SgiTransfer extends React.Component {
    static defaultProps = {
    };
    static propsType = {
    };
    constructor(props) {
        super(props);
        //初始化state
        this.state = {
            loading: false,
            transferprops: {
                listStyle: {},
                titles: [],
                operations: []
            },
            selectedKeys: [],
            targetKeys: [],//右显示数组
        }
    };

    /**
    *根据描述创建穿梭框
    *@param {父组件} parentModule
    * @param {组件描述} moduleDesc
    * @param {对象工厂} objFct
    * @param {绑定实例ID} bdInst
    * @param {make类型} type
    */

    transfer_mk(parentModule, moduleDesc, objFct, bdInst, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }
        //转换基础属性
        this.AddTFAttribute(moduleDesc, this.state.transferprops, objFct);
        //绑定公共属性 
        // CtnCommonAttribute(moduleDesc,this.Transfer,this);
    }
    AddTFAttribute(moduleDesc, transferprops, objFct) {
        //绑定数据，获取穿梭框的数据
        var transferStore = this.getMock(moduleDesc, objFct);
        if (moduleDesc._key) {
            this.state.key = moduleDesc._key;//moduleDesc._key;
        } else {
            for (let i = 0; i < transferStore.length; i++) {
                if (!transferStore[i][tranFConfConstant.key]) {
                    transferStore[i][tranFConfConstant.key] = uuid(6);
                }
            }
            this.state.key = tranFConfConstant.key;
        }
        this.state.transferprops.dataSource = transferStore;
        //宽高
        var height = moduleDesc.height;
        if (height) {
            transferprops.listStyle.height = height;
        }
        var width = moduleDesc.width;
        if (width) {
            transferprops.listStyle.width = width;
        }
        //搜索框
        var showSearch = moduleDesc.showSearch;
        if (showSearch) {
            transferprops.showSearch = showSearch;
        }
        //左右两边的标题
        var leftTitle = moduleDesc.leftTitle;
        if (leftTitle) {
            transferprops.titles[0] = leftTitle;
        }
        var rightTitle = moduleDesc.rightTitle;
        if (rightTitle) {
            transferprops.titles[1] = rightTitle;
        }
        //左右操作按键
        var rightOperation = moduleDesc.rightOperation;
        if (rightOperation) {
            transferprops.operations[0] = rightOperation;
        }
        var leftOperation = moduleDesc.leftOperation;
        if (leftOperation) {
            transferprops.operations[1] = leftOperation;
        }
    }
    /**
    * @param {*} moduleDesc
    * @param {*} transferprope
    */
    // 获取数据
    getMock(moduleDesc, objFct) {
        var insName = getConstByKey(this, moduleDesc.insName);
        var tData;
        if (insName && objFct) {
            tData = objFct.get(insName);
        }
        if (!tData) {
            return [];
        }
        return tData;
    }

    handleChange = (nextTargetKeys, direction, moveKeys) => {
        this.setState({ targetKeys: nextTargetKeys });
        tool.sgiLogger.log(nextTargetKeys);
    }
    getTargetDatas = () => {
        var data = [];
        var rightData;
        var targetKeys = this.state.targetKeys;
        var dataSource = this.state.transferprops.dataSource;
        for (let i = 0; i < targetKeys.length; i++) {
            rightData = targetKeys[i];
            for (let j = 0; j < dataSource.length; j++) {
                var leftData = dataSource[j][this.state.key];
                if (leftData == rightData) {
                    data.push(dataSource[j]);
                    break;
                }
            }
        }
        tool.sgiLogger.log('data: ', data);
        return data;
    }
    getSourceDatas = () => {
        var data = [];
        var rightData;
        var targetKeys = this.state.targetKeys;
        var num = this.state.transferprops.dataSource;
        num = copyArr(num);
        for (let i = 0; i < targetKeys.length; i++) {
            rightData = targetKeys[i];
            for (let j = 0; j < num.length; j++) {
                var leftData = num[j][this.state.key];
                if (leftData == rightData) {
                    num.splice(j, 1)
                }
            }
        }
        tool.sgiLogger.log('source:  ', this.state.transferprops.dataSource);
        tool.sgiLogger.log('num: ', num);
    }

    handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys] });
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    render = function () {
        if (!this.loaded) {
            var { parentModule, moduleDesc, objFct, bdInst, type } = this.props;
            //组装属性，初始化到this.state
            this.transfer_mk(parentModule, moduleDesc, objFct, bdInst, type);
            this.loaded = true;
        }
        return (
            <Transfer {...this.state.transferprops} render={item => item.title}
                targetKeys={this.state.targetKeys} onChange={this.handleChange}
                selectedKeys={this.state.selectedKeys} onSelectChange={this.handleSelectChange}
                rowKey={record => record[this.state.key]}
            />
        )
    }
}
export { SgiTransfer };
export default SgiTransfer;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTransfer.js